/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import toast from "react-hot-toast";
import capitalize from "./capitalize";
import warning from "./warning";
import isObject from "./isObject";

export const checkField = (value: string, message: string, onMissing: Function) => {
  if (!value) {
    toast.error(message);
    if (onMissing) onMissing();
    return true;
  }
  return false;
};

const checkFormFields = (fields: { [key: string]: any }, setErrors: Function) => {
  let isAllValid = true;
  if (!fields) warning("Fields are not defined");
  let fieldsArray = Object.entries(fields);
  const invalidFields: { [key: string]: any } = {};
  for (const [key, field] of fieldsArray) {
    let value = field;
    if (isObject(field)) {
      value = field.value;
    }
    let valueToCheck = value;
    let message = `${capitalize(key)} is required`;
    let onMissing = () => { };
    if (Array.isArray(value)) {
      // [value, message]
      valueToCheck = value[0];
      message = value[1];
      onMissing = value[2];
    }
    const isInvalid = checkField(valueToCheck, message, onMissing);
    if (isInvalid) {
      isAllValid = false;
      invalidFields[key] = message;
    } else {
      invalidFields[key] = "";
    }
  }
  if (setErrors) {
    setErrors((prev: any) => ({
      ...prev,
      ...invalidFields,
    }));
  }
  return isAllValid;
};

export default checkFormFields;
